import Const from 'constants';

const defaultStateData = {
    inner: {},
    outer: {},
    pointsType: null,
};

const defaultState = {
    data: cp(defaultStateData),
    getPointsType() {
        return this.data.pointsType;
    },
    hasBoundaries() {
        return !isEmpty(this.data.inner) && !isEmpty(this.data.outer);
    },
    hasInnerMode(mode) {
        return this.data.inner.hasOwnProperty(mode);
    },
    hasOuterMode(mode) {
        return this.data.outer.hasOwnProperty(mode);
    },
    getInnerBoundaries() {
        return {...this.data.inner};
    },
    getOuterBoundaries() {
        return {...this.data.outer};
    },
    getAdjustedInnerBoundaries() {
        const outerBoundaries = this.getOuterBoundaries();
        const innerBoundaries = this.getInnerBoundaries();
        const result = {};
        for (const [key, value] of Object.entries(innerBoundaries)) {
            if (Object.entries(value).toString() === Object.entries(outerBoundaries[key]).toString()) {
                continue;
            }
            result[key] = {};
            for (const [keyV, valueV] of Object.entries(value)) {
                if (outerBoundaries[key][keyV] !== valueV) {
                    result[key][keyV] = valueV;
                }
            }
        }
        return result;
    },
    getInnerBoundary(boundaryName, mode = Const.FLEX_MODE) {
        if (this.hasInnerMode(mode) && this.data.inner[mode].hasOwnProperty(boundaryName)) {
            return Number(this.data.inner[mode][boundaryName]);
        }
        return null;
    },
    getOuterBoundary(boundaryName, mode = Const.FLEX_MODE) {
        if (this.hasOuterMode(mode) && this.data.outer[mode].hasOwnProperty(boundaryName)) {
            return Number(this.data.outer[mode][boundaryName]);
        }
        return null;
    },
    getInnerMin(mode = Const.FLEX_MODE) {
        return this.getInnerBoundary('min', mode);
    },
    getInnerMax(mode = Const.FLEX_MODE) {
        return this.getInnerBoundary('max', mode);
    },
    getOuterMin(mode = Const.FLEX_MODE) {
        return this.getOuterBoundary('min', mode);
    },
    getOuterMax(mode = Const.FLEX_MODE) {
        return this.getOuterBoundary('max', mode);
    },
    isInBoundaries(value, mode = Const.FLEX_MODE) {
        return this.getInnerMin(mode) <= value && this.getInnerMax(mode) >= value;
    },
};

export default function (state = defaultState, action) {
    state = {...state};

    if (action.type === Const.POINTS_BOUNDARY_SET_INNER) {
        const {boundary} = action;

        Object.keys(boundary).map((mode) => {
            if (!state.hasInnerMode(mode)) {
                state.data.inner[mode] = cp(boundary[mode]);
                return;
            }
            // Avoid occasions when inner boundary can be out of outer.
            const {min = null, max = null} = boundary[mode];
            if (min !== null) {
                const outerMin = state.getOuterMin(mode);
                if (null !== outerMin && outerMin > min) {
                    state.data.inner[mode].min = outerMin;
                } else {
                    state.data.inner[mode].min = min;
                }
            }
            if (max !== null) {
                const outerMax = state.getOuterMax(mode);
                if (null !== outerMax && outerMax < max) {
                    state.data.inner[mode].max = outerMax;
                } else {
                    state.data.inner[mode].max = max;
                }
            }
        });
    } else if (action.type === Const.POINTS_BOUNDARY_SET_OUTER) {
        // Set inner boundaries before updating outer.
        const {boundary, pointsType} = action;
        const currentPointsType = state.getPointsType();

        if (isEmpty(state.data.inner) || (currentPointsType && currentPointsType !== pointsType)) {
            state.data.inner = cp(boundary);
        } else {
            Object.keys(boundary).map((mode) => {
                if (!state.hasInnerMode(mode)) {
                    state.data.inner[mode] = cp(boundary[mode]);
                    return;
                }
                if (state.getOuterMin(mode) === state.getInnerMin(mode)) {
                    state.data.inner[mode].min = boundary[mode].min;
                }
                if (state.getOuterMax(mode) === state.getInnerMax(mode)) {
                    state.data.inner[mode].max = boundary[mode].max;
                }
            });
        }

        state.data.pointsType = pointsType;
        state.data.outer = {
            ...state.data.outer,
            ...boundary,
        };
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultState,
            data: cp(defaultStateData),
        };
    }

    return state;
}
